import HeaderContents from '../../components/organism/headers/HeaderContents'
export default {
  components: { HeaderContents }
}
